import { Box, Button, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import imageBroken from "assets/img/image.svg";
import DiscountLogo from "components/DiscountLogo/DiscountLogo";
import CurrencyFormat from "react-currency-format";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Link } from "react-router-dom";
import { saveToShoppingCart } from "helpers/ShoppingCartFunctions";

export default function Kat({ catalogue }) {
  const containerStyle = {
    width: "100%",
    paddingBottom: "50px",
    display: "flex",
    flexDirection: "row",
  };

  const styleLink = {
    display: "flex",
    textDecoration: "none",
    color: "black",
    cursor: "pointer",
  };

  const itemStyle = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "500",
    textAlign: "left",
    textDecoration: "none",
    color: "black",
    paddingLeft: "10px",
  };

  const capacityStyle = {
    flexDirection: "column",
    alignItems: "flex-end",
    fontSize: "30px",
    fontWeight: "bold",
    textAlign: "left",
    width: "100%",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingTop: "35px",
      }}
    >
      <Helmet>
        <title>
          {" "}
          Kit Afinación Transmisión Automática | Afinazone | CVT DSG NS3{" "}
        </title>
        <meta
          name="description"
          content="Compra tu kit de afinación para transmisión automática compatible con tu auto: aceites, juntas, cárter, filtros, y todo lo necesario para el mantenimiento."
        />
        <meta name="keywords" content="KITS DE AFINACIÓN PARA TRANSMISIÓN" />
      </Helmet>
      {catalogue !== null &&
        catalogue.map((item, idx) => {
          return (
            <div key={idx} style={containerStyle}>
              <Box
                component="div"
                sx={{
                  flexDirection: { xs: "row", md: "row" },
                }}
                style={{
                  display: "flex",
                }}
              >
                <Box
                  component="div"
                  target="_blank"
                  style={styleLink}
                  sx={{
                    flexDirection: { xs: "row", md: "row" },
                  }}
                >
                  <Link to={`/Producto/kit-de-afinacion/${item.name}?id=${item.id}`} target="_blank">
                    <Box
                      component="img"
                      src={item.url !== null ? item.url : imageBroken}
                      alt="car"
                      sx={{
                        width: { xs: "150px", md: "200px" },
                        height: { xs: "150px", md: "200px" },
                      }}
                      style={{
                        cursor: "pointer",
                        marginRight: "15px",
                      }}
                    />
                  </Link>
                  {/* Description */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%", // Ensures the container has enough height
                    }}
                  >
                    <Box
                      component={Link}
                      to={`/Producto/kit-de-afinacion/${item.name}?id=${item.id}`}
                      target="_blank"
                      sx={{
                        fontSize: { xs: "10px", md: "18px" },
                      }}
                      style={itemStyle}
                    >
                      <div
                        style={{
                          textAlign: "left",
                          fontSize: "inherit",
                          fontFamily: "inherit",
                        }}
                      >
                        {item.name}
                      </div>
                    </Box>

                    <div style={{ marginLeft: "auto" }}>
                      <DiscountLogo
                        width="150px"
                        fontSize="15px"
                        discount={item.discountPercentage}
                      />
                    </div>

                    <div>
                      <Typography variant="body1" align="left">
                        <Box component="span" color="error.main">
                          envío GRATIS
                        </Box>
                        <Box component="span">
                          &nbsp;a partir de $549 en tu carrito
                        </Box>
                      </Typography>
                    </div>
                  </div>
                </Box>
                {/* Capacity */}
                <Box
                  component="div"
                  sx={{
                    display: { xs: "none", md: "flex" },
                  }}
                  style={capacityStyle}
                >
                  <div style={{ marginBottom: "20px" }}>
                    {item.disableOil && <DisableOil item={item} />}
                    {!item.disableOil && 
                      item.liters.map((current, idx) => {
                        return <ItemOil item={item} current={current} idx={idx} />;
                      })}
                  </div>
                </Box>
              </Box>
            </div>
          );
        })}
    </div>
  );
}

function DisableOil({ item }) {
  return (
    <div style={{ display: "flex" }}>
      {!item.discount && (
        <CurrencyFormat
          value={item.price}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          displayType={"text"}
          prefix="$"
        />
      )}
      {item.discount && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <CurrencyFormat
            value={item.price}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={"text"}
            prefix="$"
            style={{
              textDecoration: "line-through",
              color: "gray",
            }}
          />
          <CurrencyFormat
            value={item.discountPrice}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={"text"}
            prefix="$"
            style={{
              color: "#E21608",
            }}
          />
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Link to={`/Producto/kit-de-afinacion/${item.name}?id=${item.id}`} target="_blank">
          <Button
            variant="contained"
            color="primary"
            style={{
              margin: "10px",
              borderRadius: "20px",
              fontFamily: "Nunito, sans-serif",
              fontStyle: "italic",
              fontWeight: "900",
            }}
          >
            Ver Producto
          </Button>
        </Link>
        <Button
          variant="contained"
          color="primary"
          style={{
            margin: "10px",
            borderRadius: "20px",
            fontFamily: "Nunito, sans-serif",
            fontStyle: "italic",
            fontWeight: "900",
          }}
          onClick={() => { saveToShoppingCart(item.id, 'kit-de-afinacion') }}
        >
          Añadir al Carrito <AddShoppingCartIcon />
        </Button>
      </div>
    </div>
  );
}

function ItemOil({ item, current, idx }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        margin: "5px",
      }}
    >
      {current.liters} litros |
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {item.discount && (
          <>
            <CurrencyFormat
              value={current.price}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              prefix="$"
              style={{
                fontSize: "15px",
                textDecoration: "line-through",
                color: "gray",
              }}
            />
            <CurrencyFormat
              value={current.discountPrice}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              prefix="$"
              style={{
                fontSize: "17px",
                color: "#E21608",
              }}
            />
          </>
        )}
        {!item.discount && (
          <CurrencyFormat
            value={current.price}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={"text"}
            prefix="$"
          />
        )}
      </div>
      <Button
        variant="contained"
        color="primary"
        style={{ marginLeft: "30px" }}
        onClick={() => {
          saveToShoppingCart(item.id, 'kit-de-afinacion', idx)
        }}
      >
        <AddShoppingCartIcon />
      </Button>
    </div>
  );
}
